import { isAxiosError } from '../axios/is-axios-error';
import { isNetworkError } from './is-network-error';
export var ErrorType;
(function (ErrorType) {
    ErrorType["Network"] = "NETWORK";
    ErrorType["Business"] = "BUSINESS";
    ErrorType["Internal"] = "INTERNAL";
})(ErrorType || (ErrorType = {}));
const ERROR_CODES = {
    [ErrorType.Internal]: 'INTERNAL_ERROR',
    [ErrorType.Network]: 'NETWORK_ERROR',
};
const ERROR_MESSAGES = {
    [ErrorType.Internal]: 'Пожалуйста, попробуйте ещё раз позже.',
    [ErrorType.Network]: 'Проверьте подключение и попробуйте ещё раз позже.',
};
const INTERNAL_SERVICE_ERROR_CODES = [
    'BAD_REQUEST',
    'INTERNAL_SERVER_ERROR',
    'INTERNAL_ERROR',
    'WS_ERROR',
    'DEFAULT',
];
/**
 * Возвращает обработанную ошибку с дополнительной информацией.
 * @param error Ошибка от сервиса
 */
export function getServiceError(error) {
    if (isNetworkError(error)) {
        return {
            code: ERROR_CODES[ErrorType.Network],
            message: ERROR_MESSAGES[ErrorType.Network],
            errorType: ErrorType.Network,
            originalError: error,
        };
    }
    if (isAxiosError(error) && error.response) {
        const { errorCode, originalErrorCode, messages } = error.response.data ?? {};
        const message = messages?.ru || ERROR_MESSAGES[ErrorType.Internal];
        let code = errorCode || 'INTERNAL_SERVER_ERROR';
        let errorType = ErrorType.Business;
        if (INTERNAL_SERVICE_ERROR_CODES.includes(code)) {
            if (typeof originalErrorCode === 'undefined') {
                errorType = ErrorType.Internal;
            }
            else {
                code = originalErrorCode;
            }
        }
        return {
            code,
            message,
            errorType,
            originalError: error,
        };
    }
    return {
        code: ERROR_CODES[ErrorType.Internal],
        message: ERROR_MESSAGES[ErrorType.Internal],
        errorType: ErrorType.Internal,
        originalError: error,
    };
}
